module.exports = __webpack_public_path__ + "static/001-b7f2aeae29e855937aa469f5a1d233bc.png";